module.exports = __webpack_public_path__ + "img/group.4c86ca26.png";